import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class HexaPicto extends React.PureComponent {
  render() {
    const { width, height, color, type, classes, className, ...other } = this.props;
    return (
      <svg
        {...other}
        className={`${classes.hexaButton} ${classes[color]} ${className}`}
        width={width}
        height={height}
        viewBox="0 0 24 21"
      >
        <g className="hexaButtonBack">
          <path className="hexaButtonBackContent" d="M18,0l6,10.5L18,21H6L0,10.5,6,0Z" />
          <path
            className="hexaButtonBackLine"
            d="M 6.580320358276367 1 L 1.151748657226562 10.5 L 6.580320358276367 20 L 17.41967964172363 20 L 22.84825134277344 10.5 L 17.41967964172363 1 L 6.580320358276367 1 M 6 0 L 18 0 L 24 10.5 L 18 21 L 6 21 L 0 10.5 L 6 0 Z"
          />
        </g>
        <g
          className="hexaButtonLines"
          transform={type === 'cross' ? 'translate(11.5 4) rotate(45)' : 'translate(7.3 5.5)'}
        >
          <line y2="9.72" transform="translate(4.86 0)" />
          <line y2="9.72" transform="translate(9.72 4.86) rotate(90)" />
        </g>
      </svg>
    );
  }
}

HexaPicto.defaultProps = {
  width: 24,
  height: 21,
  color: 'grey',
  type: 'plus',
};

HexaPicto.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['plus', 'cross']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default withStyles(styles)(HexaPicto);
